export default "__VITE_ASSET__12529f2c__"